export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const JiliGame = {
  JiliGame: {
    slide1: {
      PirateQueen: {
        redirectUrl: "/casino/aggapjiligaming-pirate-queen",
        code: "98567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/Piratequeen.jpg",
        alt: "Pirate Queen",
        name: "Pirate Queen",
        providerName: "Jili Gaming",
      },
      WildRacer: {
        redirectUrl: "/casino/aggapjiligaming-wild-racer",
        code: "56768",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/Wildracer.jpg",
        alt: "Wild Racer",
        name: "Wild Racer",
        providerName: "Jili Gaming",
      },
      NekoFortune: {
        redirectUrl: "/casino/aggapjiligaming-neko-fortune",
        code: "98790",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/nekofortune.jpg",
        alt: "Neko Fortune",
        name: "Neko Fortune",
        providerName: "Jili Gaming",
      },
      Samba: {
        redirectUrl: "/casino/aggapjiligaming-samba",
        code: "98789",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/samba.jpg",
        alt: "Samba",
        name: "Samba",
        providerName: "Jili Gaming",
      },
      WorldCup: {
        redirectUrl: "/casino/aggapjiligaming-world-cup",
        code: "56968",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/worldcup.jpg",
        alt: "World Cup",
        name: "World Cup",
        providerName: "Jili Gaming",
      },
      BonusHunter: {
        redirectUrl: "/casino/aggapjiligaming-bonus-hunter",
        code: "67660",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/bonushunter.jpg",
        alt: "Bonus Hunter",
        name: "Bonus Hunter",
        providerName: "Jili Gaming",
      },
      JILICAISHEN: {
        redirectUrl: "/casino/aggapjiligaming-jili-caishen",
        code: "67580",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/jilicaishen.jpg",
        alt: "JILI CAISHEN",
        name: "JILI CAISHEN",
        providerName: "Jili Gaming",
      },
      MayanEmpire: {
        redirectUrl: "/casino/aggapjiligaming-mayan-empire",
        code: "67600",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/mayanempire.jpg",
        alt: "Mayan Empire",
        name: "Mayan Empire",
        providerName: "Jili Gaming",
      },
      BoneFortune: {
        redirectUrl: "/casino/aggapjiligaming-bone-fortune",
        code: "87564",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/bonefortune.jpg",
        alt: "Bone Fortune",
        name: "Bone Fortune",
        providerName: "Jili Gaming",
      },
      GoldRush: {
        redirectUrl: "/casino/aggapjiligaming-gold-rush",
        code: "67620",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/goldrush.jpg",
        alt: "Gold Rush",
        name: "Gold Rush",
        providerName: "Jili Gaming",
      },
      HappyTaxi: {
        redirectUrl: "/casino/aggapjiligaming-happy-taxi",
        code: "67567",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/happytaxi.jpg",
        alt: "Happy Taxi",
        name: "Happy Taxi",
        providerName: "Jili Gaming",
      },
      ThorX: {
        redirectUrl: "/casino/aggapjiligaming-thor-x",
        code: "67570",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/ThorX.jpg",
        alt: "Thor X",
        name: "Thor X",
        providerName: "Jili Gaming",
      },
      BookofGold: {
        redirectUrl: "/casino/aggapjiligaming-book-of-gold",
        code: "56767",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/bookofgold.jpg",
        alt: "Book of Gold",
        name: "Book of Gold",
        providerName: "Jili Gaming",
      },
      Medusa: {
        redirectUrl: "/casino/aggapjiligaming-medusa",
        code: "98788",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/medusa.jpg",
        alt: "Medusa",
        name: "Medusa",
        providerName: "Jili Gaming",
      },
      GoGoalBingo: {
        redirectUrl: "/casino/aggapjiligaming-go-goal-bingo",
        code: "98791",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/gogoalbingo.jpg",
        alt: "Go Goal Bingo",
        name: "Go Goal Bingo",
        providerName: "Jili Gaming",
      },
      ColorGame: {
        redirectUrl: "/casino/aggapjiligaming-color-game",
        code: "67630",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/colorgame.jpg",
        alt: "Color Game",
        name: "Color Game",
        providerName: "Jili Gaming",
      },
      JackpotBingo: {
        redirectUrl: "/casino/aggapjiligaming-jackpot-bingo",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/jackpotbingo.jpg",
        alt: "Jackpot Bingo",
        name: "Jackpot Bingo",
        providerName: "Jili Gaming",
      },
      LuckyBingo: {
        redirectUrl: "/casino/aggapjiligaming-lucky-bingo",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/luckybingo.jpg",
        alt: "Lucky Bingo",
        name: "Lucky Bingo",
        providerName: "Jili Gaming",
      },
      WinDrop: {
        redirectUrl: "/casino/aggapjiligaming-win-drop",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/windrop.jpg",
        alt: "Win Drop",
        name: "Win Drop",
        providerName: "Jili Gaming",
      },
      FortuneBingo: {
        redirectUrl: "/casino/aggapjiligaming-fortune-bingo",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/fortunebingo.jpg",
        alt: "Fortune Bingo",
        name: "Fortune Bingo",
        providerName: "Jili Gaming",
      },
      Baccarat: {
        redirectUrl: "/casino/aggapjiligaming-baccarat",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/baccarat.jpg",
        alt: "Baccarat",
        name: "Baccarat",
        providerName: "Jili Gaming",
      },
      iRichBingo: {
        redirectUrl: "/casino/aggapjiligaming-irich-bingo",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/iRichBingo.jpg",
        alt: "iRich Bingo",
        name: "iRich Bingo",
        providerName: "Jili Gaming",
      },
      DragonTiger: {
        redirectUrl: "/casino/aggapjiligaming-dragon-and-tiger",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/Dragon_tiger.jpg",
        alt: "Dragon & Tiger",
        name: "Dragon & Tiger",
        providerName: "Jili Gaming",
      },
      BigSmall: {
        redirectUrl: "/casino/aggapjiligaming-big-small",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/Bigsmall.jpg",
        alt: "Big Small",
        name: "Big Small",
        providerName: "Jili Gaming",
      },
      GoldenJoker: {
        redirectUrl: "/casino/aggapjiligaming-golden-joker",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/goldenjoker.jpg",
        alt: "Golden Joker",
        name: "Golden Joker",
        providerName: "Jili Gaming",
      },
      MasterTiger: {
        redirectUrl: "/casino/aggapjiligaming-master-tiger",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/mastertiger.jpg",
        alt: "Master Tiger",
        name: "Master Tiger",
        providerName: "Jili Gaming",
      },
      WildAce: {
        redirectUrl: "/casino/aggapjiligaming-wild-ace",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/Wildace.jpg",
        alt: "Wild Ace",
        name: "Wild Ace",
        providerName: "Jili Gaming",
      },
      Crazy777: {
        redirectUrl: "/casino/aggapjiligaming-crazy777",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/Crazy777.jpg",
        alt: "Crazy 777",
        name: "Crazy 777",
        providerName: "Jili Gaming",
      },
      DominoGo: {
        redirectUrl: "/casino/aggapjiligaming-domino-go",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/dominogo.jpg",
        alt: "Domino Go",
        name: "Domino Go",
        providerName: "Jili Gaming",
      },
      UltimateTexasHoldem: {
        redirectUrl: "/casino/aggapjiligaming-ultimate-texas-holdem",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/ultimatetexasholdem.jpg",
        alt: "Ultimate Texas Hold'em",
        name: "Ultimate Texas Hold'em",
        providerName: "Jili Gaming",
      },
      KenoBonusNumber: {
        redirectUrl: "/casino/aggapjiligaming-keno-bonus-number",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/kenobonusnumber.jpg",
        alt: "Keno Bonus Number",
        name: "Keno Bonus Number",
        providerName: "Jili Gaming",
      },
      CrashCricket: {
        redirectUrl: "/casino/aggapjiligaming-crash-cricket",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/crashcricket.jpg",
        alt: "Crash Cricket",
        name: "Crash Cricket",
        providerName: "Jili Gaming",
      },
      CrashGoal: {
        redirectUrl: "/casino/aggapjiligaming-crash-goal",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/crashgoal.jpg",
        alt: "Crash Goal",
        name: "Crash Goal",
        providerName: "Jili Gaming",
      },
      FortuneRoulette: {
        redirectUrl: "/casino/aggapjiligaming-fortune-roulette",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/fortuneroulette.jpg",
        alt: "Fortune Roulette",
        name: "Fortune Roulette",
        providerName: "Jili Gaming",
      },
      CricketRoulette: {
        redirectUrl: "/casino/aggapjiligaming-cricket-roulette",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/cricketroulette.jpg",
        alt: "Cricket Roulette",
        name: "Cricket Roulette",
        providerName: "Jili Gaming",
      },
      SuperESabong: {
        redirectUrl: "/casino/aggapjiligaming-super-e-sabong",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/super-e-sabong.jpg",
        alt: "Super E-Sabong",
        name: "Super E-Sabong",
        providerName: "Jili Gaming",
      },
      ThaiHilo: {
        redirectUrl: "/casino/aggapjiligaming-thai-hilo",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/thaihilo.jpg",
        alt: "Thai Hilo",
        name: "Thai Hilo",
        providerName: "Jili Gaming",
      },
      BoxingExtravaganza: {
        redirectUrl: "/casino/aggapjiligaming-boxing-extravaganza",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/boxingextravaganza.jpg",
        alt: "Boxing Extravaganza",
        name: "Boxing Extravaganza",
        providerName: "Jili Gaming",
      },
      JhandiMunda: {
        redirectUrl: "/casino/aggapjiligaming-jhandi-munda",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/jhandimunda.jpg",
        alt: "Jhandi Munda",
        name: "Jhandi Munda",
        providerName: "Jili Gaming",
      },
      SuperAceScratch: {
        redirectUrl: "/casino/aggapjiligaming-super-ace-scratch",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/superacescratch.jpg",
        alt: "Super Ace Scratch",
        name: "Super Ace Scratch",
        providerName: "Jili Gaming",
      },
      FishPrawnCrab: {
        redirectUrl: "/casino/aggapjiligaming-fish-prawn-crab",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/fishprawncrab.jpg",
        alt: "Fish Prawn Crab",
        name: "Fish Prawn Crab",
        providerName: "Jili Gaming",
      },
      LuckyJaguar: {
        redirectUrl: "/casino/aggapjiligaming-lucky-jaguar",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/luckyjaguar.jpg",
        alt: "Lucky Jaguar",
        name: "Lucky Jaguar",
        providerName: "Jili Gaming",
      },
      Shōgun: {
        redirectUrl: "/casino/aggapjiligaming-shogun",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/shogun.jpg",
        alt: "Shōgun",
        name: "Shōgun",
        providerName: "Jili Gaming",
      },
      MoneyPot: {
        redirectUrl: "/casino/aggapjiligaming-money-pot",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/moneypot.jpg",
        alt: "Money Pot",
        name: "Money Pot",
        providerName: "Jili Gaming",
      },
      NightfallHunting: {
        redirectUrl: "/casino/aggapjiligaming-nightfall-hunting",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/nightfallhunting.jpg",
        alt: "Nightfall Hunting",
        name: "Nightfall Hunting",
        providerName: "Jili Gaming",
      },
      PotDragons3: {
        redirectUrl: "/casino/aggapjiligaming-3-pot-dragons",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/3potdragon.jpg",
        alt: "3 Pot Dragons",
        name: "3 Pot Dragons",
        providerName: "Jili Gaming",
      },
      Poseidon: {
        redirectUrl: "/casino/aggapjiligaming-poseidon",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/poseidon.jpg",
        alt: "Poseidon",
        name: "Poseidon",
        providerName: "Jili Gaming",
      },
      LuckyPiggy3: {
        redirectUrl: "/casino/aggapjiligaming-3-lucky-piggy",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/3luckypiggy.jpg",
        alt: "3 Lucky Piggy",
        name: "3 Lucky Piggy",
        providerName: "Jili Gaming",
      },
      EgyptsGlow: {
        redirectUrl: "/casino/aggapjiligaming-egypts-glow",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/egyptsglow.jpg",
        alt: "Egypt's Glow",
        name: "Egypt's Glow",
        providerName: "Jili Gaming",
      },
      PartyStar: {
        redirectUrl: "/casino/aggapjiligaming-party-star",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/partystar.jpg",
        alt: "Party Star",
        name: "Party Star",
        providerName: "Jili Gaming",
      },
      MoneyComingExpandBets: {
        redirectUrl: "/casino/aggapjiligaming-money-coming-expand-bets",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/moneycomingexpandedbets.jpg",
        alt: "Money Coming Expand Bets",
        name: "Money Coming Expand Bets",
        providerName: "Jili Gaming",
      },
      SuperAceeluxe: {
        redirectUrl: "/casino/aggapjiligaming-super-ace-deluxe",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/superacedeluxe.jpg",
        alt: "Super Ace Deluxe",
        name: "Super Ace Deluxe",
        providerName: "Jili Gaming",
      },
      LegacyofEgypt: {
        redirectUrl: "/casino/aggapjiligaming-legacy-of-egypt",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/legacyofegypt.jpg",
        alt: "Legacy of Egypt",
        name: "Legacy of Egypt",
        providerName: "Jili Gaming",
      },
      ThePigHouse: {
        redirectUrl: "/casino/aggapjiligaming-the-pig-house",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/thepighouse.jpg",
        alt: "The Pig House",
        name: "The Pig House",
        providerName: "Jili Gaming",
      },
      CrazyHunter2: {
        redirectUrl: "/casino/aggapjiligaming-crazy-hunter-2",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/crazyhunter2.jpg",
        alt: "Crazy Hunter 2",
        name: "Crazy Hunter 2",
        providerName: "Jili Gaming",
      },
      FortuneKingJackpot: {
        redirectUrl: "/casino/aggapjiligaming-fortune-king-jackpot",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/fortunekingjackpot.jpg",
        alt: "Fortune King Jackpot",
        name: "Fortune King Jackpot",
        providerName: "Jili Gaming",
      },
      VideoPoker: {
        redirectUrl: "/casino/aggapjiligaming-video-poker",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/videopoker.jpg",
        alt: "Video Poker",
        name: "Video Poker",
        providerName: "Jili Gaming",
      },
      CaribbeanStudPoker: {
        redirectUrl: "/casino/aggapjiligaming-caribbean-stud-poker",
        code: "98566",
        casino: "aura",
        provider: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/jili-game/caribbeanstudpoker.jpg",
        alt: "Caribbean Stud Poker",
        name: "Caribbean Stud Poker",
        providerName: "Jili Gaming",
      },
    },
    name: "Jili Games",
    key: "JiliGame",
  },
};
